const gallerySwiper = new Swiper('.swiper-gallery', {
  loop: true,
  slidesPerView: 3,
  slidesPerGroup: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-gallery-next',
    prevEl: '.swiper-gallery-prev'
  },
  pagination: {
    el: '.swiper-gallery-pagination',
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    640: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  }
});